<template>
  <div class="content flex flex-col justify-center items-center gap-5 w-full bg-white rounded-md shadow-ts1 mb-24 min-h-[100vh] md:min-h-[80vh]">
    <img style="width: 150px" src="../../../assets/img/crypto-deposit-failed.svg" />
    <h1 class="text-3xl text-center font-semibold font-display">{{ $t('deposit_failed').tTitle() }}</h1>
    <p class="text-center font-display">
      <i18n tag="label" place="here">
        {{ $t('you_can_try').tTitle() }}
        <router-link :to="'/' + Language + '/finance'">{{ $t('here').tTitle() }}</router-link>
      </i18n>
    </p>
    <p class="text-center font-display">{{ reason ? `${$t('reason')} ${reason}` : '' }}</p>
    <router-link
      :to="'/' + Language + '/finance'"
      class="px-3 py-3 h-full bg-blue rounded-md text-white appearance-none font-bold text-base text-center ltr:float-right rtl:float-left cursor-pointer"
    >
      {{ $t('back_to_transactions') }}
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['reason'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {},
}
</script>
